import { render, staticRenderFns } from "./accountinvoices.vue?vue&type=template&id=5241c8e3&scoped=true"
import script from "./accountinvoices.vue?vue&type=script&lang=js"
export * from "./accountinvoices.vue?vue&type=script&lang=js"
import style0 from "./accountinvoices.vue?vue&type=style&index=0&id=5241c8e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241c8e3",
  null
  
)

export default component.exports